import styled from "styled-components"


export const ComponentsPage = () => {
  return (
    <StyleWrap>
      ComponentsPage
    </StyleWrap>
  )
}

const StyleWrap = styled.div`

`;